import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('Spiner').create(() => ({
  root: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'row',
    justifySelf: 'center',
    alignSelf: 'center',
    alignItems: 'center',
    justifyContent: 'center',

    '&[data-size="s"]': {
      width: '22px',
      height: '22px',
    },

    '&[data-size="m"]': {
      width: '32px',
      height: '32px',
    },

    '&[data-size="l"]': {
      width: '128px',
      height: '128px',
    },

    span: {
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      display: 'block',
      position: 'absolute',
      border: '3px solid',
      '&[data-size="l"]': {
        border: '6px solid',
        borderColor: '#FFFFFF #FFFFFF29 #FFFFFF29 #FFFFFF29',
      },
      borderColor: '#FFFFFF #FFFFFF29 #FFFFFF29 #FFFFFF29',
      animation: 'loading 1.5s linear infinite',
    },

    '@keyframes loading': {
      '0%': {
        transform: 'rotate(0deg)',
      },

      '25%': {
        transform: 'rotate(90deg)',
      },

      '50%': {
        transform: 'rotate(180deg)',
      },
      '75%': {
        transform: 'rotate(270deg)',
      },
      '100%': {
        transform: 'rotate(360deg)',
      },
    },
  },
}))
